module.exports = __webpack_public_path__ + "img/title.07fbc29a.png";